import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(50, 50, 50, 0.8);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  width: 50px;
`;

export default (props = {}) => {
  return (
    <Overlay data-testid={props["data-testid"]}>
      <Content>
        <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path
            opacity=".25"
            d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
          />
          <path
            d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z"
            transform="rotate(218.551 16 16)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 16 16"
              to="360 16 16"
              dur="0.8s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
      </Content>
    </Overlay>
  );
};
